import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Button, TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { ButtonGroup } from "@material-ui/core";
import { TimePicker } from "@material-ui/pickers";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox";
import Asignacion from "src/services/asignacion";
import DatePicker from "src/components/DatePicker";
import { IonAlert } from "@ionic/react";


// Formatea un numero/string a separador de miles con punto (formato Guarani).
// Maneja tanto enteros ("150000") como decimales del backend ("150000.00").
// Trunca la parte decimal porque Guarani no usa centavos.
const formatMiles = (val) => {
  if (val === "" || val === null || val === undefined) return "";
  const num = Math.floor(Number(val));
  if (!Number.isFinite(num) || num < 0) return "";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "scroll",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function TransitionsModal(props) {
  const classes = useStyles();
  const {onConfirm } = props;
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  //estado modal
  const [open, setOpen] = React.useState(false);
  //dias
  const [checked, setChecked] = React.useState([]);
  //hora
  const [value, setValue] = useState(new Date());
  const [valor, setValor] = useState(new Date());
  //fecha
  const [Fecha, setFecha] = React.useState(new Date());
  //configurar hooks
  const [rows, setRows] = useState([{}]);

  // Beneficios: Tarjeta Gourmet y Viatico Combustible/Pasaje
  const [viaticoGourmet, setViaticoGourmet] = useState(false);
  const [viaticoOperario, setViaticoOperario] = useState(false);
  const [viaticoGourmetMonto, setViaticoGourmetMonto] = useState("");
  const [viaticoOperarioMonto, setViaticoOperarioMonto] = useState("");
  const [gourmetDisponible, setGourmetDisponible] = useState("0");
  const [viaticoDisponible, setViaticoDisponible] = useState("0");

  useEffect(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  useEffect(() => {
    if (open) {
      (async () => {
        await loadDisponibilidad();
      })();
    }
  }, [open]);

  const loadData = async () => {
    const url = await Asignacion.listarOperarios();
    const response = url;
    setRows(response);
  };

  const loadDisponibilidad = async () => {
    const ps_id = sessionStorage.getItem("ps_id");
    if (!ps_id) return;
    const disp = await Asignacion.obtenerDisponibilidadBeneficios(ps_id);
    if (disp) {
      setGourmetDisponible(disp.gourmet_disponible || "0");
      setViaticoDisponible(disp.viatico_disponible || "0");
    } else {
      setGourmetDisponible("0");
      setViaticoDisponible("0");
    }
    // Reset al abrir
    setViaticoGourmet(false);
    setViaticoOperario(false);
    setViaticoGourmetMonto("");
    setViaticoOperarioMonto("");
  };

  const onChange = (timeValue) => {
    setValue(timeValue);
  };

  const onChangeSalida = (timeValue) => {
    setValor(timeValue);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (event) => {
    const datos = {};

    const horaEntrada = value.toISOString().slice(11, 16);
    const horaSalida = valor.toISOString().slice(11, 16);
    const FechaInicio = JSON.stringify(Fecha.toJSON()).slice(1, 11);
    // const FechaFinal = JSON.stringify(FechaFin.toJSON()).slice(1,11);
    datos.fecha_inicio = FechaInicio;
    // datos.fecha_fin = FechaFinal;

    if (checked) {
      checked.values();
      for (let checkeado of checked) {
        if (checkeado === "LUNES" && value) {
          datos.lun_ent = horaEntrada;
        }
        if (checkeado === "LUNES" && valor) {
          datos.lun_sal = horaSalida;
        }
        if (checkeado === "MARTES" && value) {
          datos.mar_ent = horaEntrada;
        }
        if (checkeado === "MARTES" && valor) {
          datos.mar_sal = horaSalida;
        }
        if (checkeado === "MIERCOLES" && value) {
          datos.mie_ent = horaEntrada;
        }
        if (checkeado === "MIERCOLES" && valor) {
          datos.mie_sal = horaSalida;
        }
        if (checkeado === "JUEVES" && value) {
          datos.jue_ent = horaEntrada;
        }
        if (checkeado === "JUEVES" && valor) {
          datos.jue_sal = horaSalida;
        }
        if (checkeado === "VIERNES" && value) {
          datos.vie_ent = horaEntrada;
        }
        if (checkeado === "VIERNES" && valor) {
          datos.vie_sal = horaSalida;
        }
        if (checkeado === "SABADO" && value) {
          datos.sab_ent = horaEntrada;
        }
        if (checkeado === "SABADO" && valor) {
          datos.sab_sal = horaSalida;
        }
        if (checkeado === "DOMINGO" && value) {
          datos.dom_ent = horaEntrada;
        }
        if (checkeado === "DOMINGO" && valor) {
          datos.dom_sal = horaSalida;
        }
      }
    }

    if (event) {
      if (horaSalida.valueOf() < horaEntrada.valueOf()) {
        alert("Hora de salida es menor a la hora de entrada");
        handleClose();
      }else if(checked < 1){
          setAlertMessage('Por favor elije un dia de la semana')
          setShowAlert(true)
          handleClose()
        }
      else {
        // Validacion de montos de viatico antes de enviar.
        // El estado guarda solo digitos (sin puntos), por lo que parseFloat alcanza.
        const parseMonto = (v) => (v ? parseFloat(String(v).replace(/\D/g, "")) : NaN);
        const dispG = parseFloat(gourmetDisponible) || 0;
        const dispV = parseFloat(viaticoDisponible) || 0;
        let montoG = null;
        let montoV = null;
        if (viaticoGourmet) {
          montoG = parseMonto(viaticoGourmetMonto);
          if (isNaN(montoG) || montoG <= 0) {
            setAlertMessage("Debe ingresar un monto valido para Tarjeta Gourmet");
            setShowAlert(true);
            return;
          }
          if (montoG > dispG) {
            setAlertMessage(`El monto de Tarjeta Gourmet supera el disponible (${formatMiles(dispG)} ₲)`);
            setShowAlert(true);
            return;
          }
        }
        if (viaticoOperario) {
          montoV = parseMonto(viaticoOperarioMonto);
          if (isNaN(montoV) || montoV <= 0) {
            setAlertMessage("Debe ingresar un monto valido para Viatico Combustible/Pasaje");
            setShowAlert(true);
            return;
          }
          if (montoV > dispV) {
            setAlertMessage(`El monto de Viatico Combustible/Pasaje supera el disponible (${formatMiles(dispV)} ₲)`);
            setShowAlert(true);
            return;
          }
        }

        datos.ps_id = sessionStorage.getItem("ps_id");
        datos.operario = sessionStorage
          .getItem("op")
          .concat(" - ", sessionStorage.getItem("legajo"));
        datos.viatico_gourmet = viaticoGourmet;
        datos.viatico_operario = viaticoOperario;
        if (viaticoGourmet) datos.viatico_gourmet_monto = montoG;
        if (viaticoOperario) datos.viatico_operario_monto = montoV;
        //envia un jason en base a lo que el fiscal elige en el modal
        Asignacion.guardarAsignacion(datos)
          .then((response) => {
            if (response.status === 200) {
              handleClose();
              setAlertMessage(response.data.mensaje);
              setShowAlert(true);
              onConfirm();
            }else if(response === 500){
              setAlertMessage(response.data.mensaje);
              setShowAlert(true);
            }
          })
          .catch((error) => {
              setAlertMessage(error.response.data.error);
              setShowAlert(true);
          });
        handleClose();
      }
    }
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const dia = [
    "LUNES",
    "MARTES",
    "MIERCOLES",
    "JUEVES",
    "VIERNES",
    "SABADO",
    "DOMINGO",
  ];

  return (
    <div>
      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        
        message={alertMessage}
        buttons={["cerrar"]}
      />
      <Button
        className="mt-2 mb-2"
        style={{ color: "white" }}
        onClick={handleOpen}
      >
        + ASIGNACION
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 0.5,
        }}
      > 
        <Fade in={open}>
          <div className={classes.paper}>
            <div>
              <div>
                <TimePicker
                  display="default"
                  is24Hour={true}
                  mode="time"
                  label="ENTRADA"
                  onChange={onChange}
                  value={value}
                />
                <TimePicker
                  display="default"
                  is24Hour={true}
                  mode="time"
                  label="SALIDA"
                  onChange={onChangeSalida}
                  value={valor}
                />
              </div>
              <br></br>
              <div style={{ width: "100%" }}>
                <DatePicker
                  className="half"
                  value={Fecha}
                  placeholder="Fecha Inicio"
                  setValue={setFecha}
                />
                {/* <DatePicker className="half" value={FechaFin} placeholder='Fecha Fin' setValue={setFechaFin}/> */}
              </div>
            </div>

            <div>
              <h2 id="transition-modal-title" style={{ color: "black" }}>
                Seleccione los dias
              </h2>

              <List dense className={classes.root}>
                {dia.map((value) => {
                  const labelId = `checkbox-list-secondary-label-${value}`;
                  if (`${value}` === dia) {
                    return dia.indexOf(dia);
                  }
                  return (
                    <ListItem key={value} button>
                      <ListItemText id={labelId} primary={`${value}`} />
                      <ListItemSecondaryAction>
                        <Checkbox
                          edge="end"
                          onChange={handleToggle(value)}
                          checked={checked.indexOf(value) !== -1}
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </div>

            <div style={{ marginTop: "10px" }}>
              <List dense>
                <ListItem button>
                  <ListItemText
                    primary="Tarjeta Gourmet"
                    secondary={`Disp: ${formatMiles(gourmetDisponible)} ₲`}
                  />
                  <ListItemSecondaryAction>
                    <Checkbox
                      edge="end"
                      checked={viaticoGourmet}
                      onChange={(e) => {
                        setViaticoGourmet(e.target.checked);
                        if (!e.target.checked) setViaticoGourmetMonto("");
                      }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                {viaticoGourmet && (
                  <ListItem>
                    <TextField
                      type="text"
                      inputMode="numeric"
                      label="Monto Gourmet"
                      value={formatMiles(viaticoGourmetMonto)}
                      onChange={(e) => setViaticoGourmetMonto(e.target.value.replace(/\D/g, ""))}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">₲</InputAdornment>,
                      }}
                      fullWidth
                    />
                  </ListItem>
                )}

                <ListItem button>
                  <ListItemText
                    primary="Viatico Combustible/Pasaje"
                    secondary={`Disp: ${formatMiles(viaticoDisponible)} ₲`}
                  />
                  <ListItemSecondaryAction>
                    <Checkbox
                      edge="end"
                      checked={viaticoOperario}
                      onChange={(e) => {
                        setViaticoOperario(e.target.checked);
                        if (!e.target.checked) setViaticoOperarioMonto("");
                      }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                {viaticoOperario && (
                  <ListItem>
                    <TextField
                      type="text"
                      inputMode="numeric"
                      label="Monto Viatico"
                      value={formatMiles(viaticoOperarioMonto)}
                      onChange={(e) => setViaticoOperarioMonto(e.target.value.replace(/\D/g, ""))}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">₲</InputAdornment>,
                      }}
                      fullWidth
                    />
                  </ListItem>
                )}
              </List>
            </div>

            <div>
              <ButtonGroup
                variant="contained"
                style={{ display: "flex" }}
                color="primary"
                aria-label="contained primary button group"
              >
                <Button
                  className="mt-2 mb-2"
                  style={{
                    left: "15px",
                    background: "#910434",
                    color: "white",
                    borderRadius: "3px",
                  }}
                  onClick={handleClick}
                >
                  CONFIRMAR
                </Button>
                <Button
                  className="mt-2 mb-2"
                  onClick={handleClose}
                  style={{
                    left: "70px",
                    background: "#910434",
                    color: "white",
                    borderRadius: "3px",
                  }}
                >
                  CANCELAR
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
